import React, {FC, ReactNode} from "react"
import styled from "styled-components"
import {isString} from "lodash"

import Card from "@irati/ui/src/Layout/Card"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button/Button"
import {Tooltip} from "@irati/ui/src/Tooltip"

interface Props extends InjectIntl {
  title: string
  info: string
  icon: IconTypes
  iconColor: string
  children: any
  tooltip?: string
  buttonText?: string | ReactNode
  onClick: () => void
  usePrimaryBtn?: boolean
}

const FlexCard = styled(Card)`
  flex: 1 1 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 350px;
`

const Widget: FC<Props> = ({title, icon, iconColor, buttonText, onClick, children, tooltip, usePrimaryBtn, formatMessage}) => {
  return (
    <FlexCard>
      <div>
        <Flex justifyContent="space-between">
          <Flex marginBottom={2} alignItems="center" gap={0.5}>
            <Body>
              <FormattedMessage id={title} />
            </Body>
            {tooltip && (
              <Tooltip tooltipChildren={formatMessage({id: tooltip})}>
                <Icon marginLeft icon={IconTypes.info} size={12} />
              </Tooltip>
            )}
          </Flex>
          <Icon icon={icon} size={19} color={iconColor} />
        </Flex>
        {children}
      </div>
      {buttonText && (
        <Flex justifyContent="flex-end" marginTop={1}>
          <Button primary={usePrimaryBtn} onClick={onClick}>
            {isString(buttonText) ? <FormattedMessage id={buttonText} /> : buttonText}
          </Button>
        </Flex>
      )}
    </FlexCard>
  )
}

export default injectIntl(Widget)
